export default __webpack_public_path__ + "static/media/bg-header-mobile.8980979d.png";